// extracted by mini-css-extract-plugin
export default {"cityCard":"CityCard_cityCard__6tRu3"};